import React, {useState} from 'react'
import TextField from '@material-ui/core/TextField'


export default function({
    handleFormChange, 
    setActiveSection, 
    setUploadOpen,
    sopState,
    setSopState,
    attachments,
    children, 
}){
    


    return (
        <div>
            <form noValidate autoComplete="off">
                
                <div>
                    <TextField id="masterDoc" label="Master Doc" value={sopState.masterDoc?sopState.masterDoc:""} 
                    onChange={(e) => handleFormChange(e)}
                    helperText="2 to 4 Characters" 
                    inputProps={{ maxLength: 4 }}
                    style={{width:'10%', marginRight:15, marginBottom:20}}
                    />
                    
                    <TextField id="typeOfDoc" label="Type of Doc" value={sopState.typeOfDoc?sopState.typeOfDoc:""} 
                    onChange={(e) => handleFormChange(e)}
                    helperText="1 Character"
                    inputProps={{ maxLength: 1 }} 
                    style={{width:'10%', marginLet:15, marginRight:15, marginBottom:20}}
                    />  
                    <TextField id="documentKey" label="Document Key" value={sopState.documentKey?sopState.documentKey:""} 
                    helperText="2 to 4 Characters"
                    inputProps={{ maxLength: 4 }}
                    onChange={(e) => handleFormChange(e)} 
                    style={{width:'10%', marginLet:15, marginRight:15, marginBottom:20}}
                    />
                    
                    <TextField id="name" label="Name" value={sopState.name?sopState.name:""} 
                    onChange={(e) => handleFormChange(e)} 
                    style={{width:'47%', marginLet:15, marginBottom:20}}
                    />
                </div>
            </form>
        </div>
    )
}